// extracted by mini-css-extract-plugin
export var songs_list = "DiskSongs-module--songs_list--gKBaJ";
export var song_item = "DiskSongs-module--song_item--bOnXN";
export var song_item_guide = "DiskSongs-module--song_item_guide--d8ccX";
export var song_name = "DiskSongs-module--song_name--j-N1a";
export var song_number = "DiskSongs-module--song_number--D88hy";
export var song_duration = "DiskSongs-module--song_duration--1eM1e";
export var icon = "DiskSongs-module--icon--CI310";
export var cc = "DiskSongs-module--cc--kSxIU";
export var translated = "DiskSongs-module--translated--Ctrcb";